/**
 * Created by koqiui on 2017-04-09.
 */
import { Utils, Jqext } from '../../app.base'
import { Routes, Vue, MsgBox } from '../../app.vues';



import SwbMerchantRealComListSelect from './MerchantRealComListSelect'

Vue.regist(SwbMerchantRealComListSelect);

/** 商户实体公司通用选择 */
export function selectMerchantRealComDlg(params, callbackFunc) {
    let theDlg = Vue.$showDialog({
        title: "商户实体公司-选择",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-merchant-real-com-list-select :bizUnitId="bizUnitId" ref="swb_real_com_select"></swb-merchant-real-com-list-select>',
        data: {
            bizUnitId: params['bizUnitId'] || null
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_real_com_select.getDlgResult() || {};
            if(dlgResult.type == 'info') {
                callbackFunc(dlgResult.data, theDlg);
            } else {
                MsgBox.warning(dlgResult.message);
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/realCom/dialog.js
// module id = 191
// module chunks = 1